<div class="p-2 py-md-3 px-md-2">
	<full-calendar #calendar [options]="calendarOptions"></full-calendar>
</div>
